import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { PHARMACY_SORT_COLUMNS } from "@/features/synchronizacja-apteki/types";
import { ensureElementVisible } from "@/lib/route-guards";

const PharmaciesSyncListPage = lazy(() =>
	import("@/features/synchronizacja-apteki/pharmacies-list-page").then((m) => ({
		default: m.PharmaciesSyncListPage,
	})),
);

// Zakres, sort i filtry kolumn deep-linkowalne; zły parametr ze starego linku
// traktujemy jak brak zamiast wywracać trasę (FARMASTER-FRONTEND-31/33/34).
const searchSchema = z.object({
	scope: z.string().optional().catch(undefined),
	sortBy: z.enum(PHARMACY_SORT_COLUMNS).optional().catch(undefined),
	sortDir: z.enum(["asc", "desc"]).optional().catch(undefined),
	// Filtry nagłówków DataTable — generyczny JSON [{id, value}].
	columnFilters: z.string().optional().catch(undefined),
	// Apteka otwarta w panelu (KS ID) — F5 i link wracają do tego samego panelu.
	apteka: z.coerce.number().int().positive().optional().catch(undefined),
	// D89: filtr zestawienia panelu — przyczyna (`cause` z backendu) albo komórka mapy
	// `<tabela>:<YYYY-MM>`; wzajemnie się wykluczają (ustawia je panel).
	przyczyna: z
		.string()
		.regex(/^[a-z0-9_]{1,40}$/)
		.optional()
		.catch(undefined),
	miesiac: z
		.string()
		.regex(/^[a-z0-9_]{1,32}:\d{4}-\d{2}$/)
		.optional()
		.catch(undefined),
	// Zakres miesięcy panelu (`YYYY-MM`, włącznie): mapa, przyczyny, zestawienie, SUCKER.
	od: z
		.string()
		.regex(/^\d{4}-(0[1-9]|1[0-2])$/)
		.optional()
		.catch(undefined),
	do: z
		.string()
		.regex(/^\d{4}-(0[1-9]|1[0-2])$/)
		.optional()
		.catch(undefined),
	// Panel na cały ekran.
	pelny: z.boolean().optional().catch(undefined),
});

export type SynchronizacjaAptekiSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/synchronizacja/apteki/")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.synchronizacja-apteki",
			location.pathname,
		);
	},
	component: PharmaciesSyncListPage,
	validateSearch: (search: Record<string, unknown>): SynchronizacjaAptekiSearch =>
		searchSchema.parse(search),
});
